import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import InputStyles from "../InputStyles";
import { generateRandomString } from "../../../utils/helpers";

const CheckboxInput = ({
  register,
  fieldName,
  label,
  required,
  formState: { errors = {} } = {},
  errorMessage = "Please check this box to proceed",
  defaultChecked = false,
  disabled = false,
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  return (
    <InputStyles className="checkbox-input">
      <div className="checkbox-input__container">
        <input
          id={inputRandomId}
          {...register(fieldName, {
            required,
          })}
          disabled={disabled}
          type="checkbox"
          className="checkbox"
          defaultChecked={defaultChecked}
        />
        <div className="label-container">
          <div className="label-container">
            {required && <span className="required-asterisk">*</span>}
            {typeof label === "string" ? (
              <label
                htmlFor={inputRandomId}
                dangerouslySetInnerHTML={{ __html: label }}
              />
            ) : (
              <label htmlFor={inputRandomId}>{label}</label>
            )}
          </div>{" "}
        </div>
      </div>
      {errors[fieldName] && <span className="input-error">{errorMessage}</span>}
    </InputStyles>
  );
};
export default CheckboxInput;

// CheckboxInput.propTypes = {
//   register: PropTypes.func.isRequired,
//   fieldName: PropTypes.string.isRequired,
//   label: PropTypes.node.isRequired,
//   required: PropTypes.bool,
//   defaultChecked: PropTypes.bool,
//   disabled: PropTypes.bool,
// };
